import { cx, styled } from "simplydo/react/styled";
import { Card } from "simplydo/react/ui/card";

import type { CardGroupProps } from "./Card.types";

const Group = styled.div<{ $itemsPerRow?: number }>`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0;
  gap: 1em;
  &.sets-items-per-row > ${Card} {
    /* Override Card's standalone 290px default (Semantic .ui.cards > .card) */
    margin: 0 !important;
    width: ${({ $itemsPerRow }) =>
      $itemsPerRow
        ? "calc((100% - " +
          ($itemsPerRow - 1) +
          " * 1em) / " +
          $itemsPerRow +
          ")"
        : "290px"} !important;
    max-width: ${({ $itemsPerRow }) =>
      $itemsPerRow
        ? "calc((100% - " +
          ($itemsPerRow - 1) +
          " * 1em) / " +
          $itemsPerRow +
          ")"
        : "290px"};
  }

  &.is-stackable {
    @media only screen and (max-width: 767px) {
      flex-direction: column;
      > * {
        width: 100% !important;
        max-width: 100% !important;
      }
    }
  }
`;

const CardGroupComponent = (props: CardGroupProps) => {
  const { itemsPerRow, stackable, children, className, style, onClick } = props;
  const n =
    typeof itemsPerRow === "string" ? parseInt(itemsPerRow, 10) : itemsPerRow;
  return (
    <Group
      className={cx(
        stackable && "is-stackable",
        stackable && "stackable",
        itemsPerRow && "sets-items-per-row",
        className,
      )}
      style={style}
      onClick={onClick}
      $itemsPerRow={n}
    >
      {children}
    </Group>
  );
};

export const CardGroup = styled(CardGroupComponent)``;
